import { injectable } from 'tsyringe';
import type { PlanSummary } from '@bmai/shared';
import { BaseViewModel } from '@/shared/viewmodels/BaseViewModel';
import { OperatorPlansService, type PlanUpsert } from './OperatorPlansService';

@injectable()
export class OperatorPlansViewModel extends BaseViewModel {
    plans: PlanSummary[] | null = null;
    loading = true;
    error: string | null = null;

    constructor(private readonly service: OperatorPlansService) {
        super();
    }

    async load(): Promise<void> {
        this.loading = true;
        this.error = null;
        this.notifyChange();
        try {
            this.plans = await this.service.list();
        } catch (e) {
            this.plans = null;
            this.error = e instanceof Error ? e.message : 'Failed to load plans';
        } finally {
            this.loading = false;
            this.notifyChange();
        }
    }

    async save(id: string | null, input: PlanUpsert): Promise<void> {
        if (id) await this.service.update(id, input);
        else await this.service.create(input);
        await this.load();
    }

    async remove(id: string): Promise<void> {
        await this.service.remove(id);
        await this.load();
    }
}
